import HeaderLeaf from "./components/HeaderLeaf";
import FooterLeaf from "./components/FooterLeaf";

if (!("customElements" in window)) {
  setTimeout(() => {
    if (!window.customElements.get("arcteryx-leaf-header")) {
      window.customElements.define("arcteryx-leaf-header", HeaderLeaf);
    }

    if (!window.customElements.get("arcteryx-leaf-footer")) {
      window.customElements.define("arcteryx-leaf-footer", FooterLeaf);
    }
  }, 2000);
}

if (!window.customElements.get("arcteryx-leaf-header")) {
  window.customElements.define("arcteryx-leaf-header", HeaderLeaf);
}

if (!window.customElements.get("arcteryx-leaf-footer")) {
  window.customElements.define("arcteryx-leaf-footer", FooterLeaf);
}
